import L from 'leaflet';
import 'leaflet-draw';
import { isEmpty } from 'lodash';

import { VIDEO_COORDINATE_DATA_TYPES } from '../../api/Videos/Videos';

const CIRCLE_MARKER_STYLE = {
  color: '#000000',
  fillColor: '#3388ff',
  fillOpacity: 1,
  weight: 1
};

/**
 * Draws the video geometry on the leaflet map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.coordinatesDataType - The video coordinates data type.
 * @param {object} arg.latLng0 - The video first feature coordinates.
 * @param {object} arg.track - The video track.
 * @param {object} arg.drawnItems - The feature group where the geometry layers will be.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @returns {object} The leaflet feature group object added to the map with the geometry layers.
 */

const drawVideoGeometry = ({
  leafletMap,
  coordinatesDataType,
  latLng0,
  track,
  drawnItems,
  isUpdate = false
}) => {
  let newItemsToDraw = '';
  if (!isUpdate) {
    newItemsToDraw = new L.FeatureGroup().addTo(leafletMap);
  } else {
    drawnItems.clearLayers();
    newItemsToDraw = drawnItems;
  }

  if (coordinatesDataType !== VIDEO_COORDINATE_DATA_TYPES.POINT && !isEmpty(track)) {
    newItemsToDraw.addLayer(L.geoJSON(track).getLayers()[0]);
  }

  if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.POINT && !isEmpty(latLng0)) {
    newItemsToDraw.addLayer(L.circleMarker([latLng0[1], latLng0[0]], CIRCLE_MARKER_STYLE));
  }

  return newItemsToDraw;
};

export default drawVideoGeometry;
